// extracted by mini-css-extract-plugin
export default {"logoLink":"logoLink--Mj2V0","logo":"logo--Mj2V0"};